/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_InvitingInputs */

const zh_share_inviting = /** @type {(inputs: Share_InvitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀请中...`)
};

const en_share_inviting = /** @type {(inputs: Share_InvitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inviting...`)
};

const es_share_inviting = /** @type {(inputs: Share_InvitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitando...`)
};

/**
* | output |
* | --- |
* | "Inviting..." |
*
* @param {Share_InvitingInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const share_inviting = /** @type {((inputs?: Share_InvitingInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_InvitingInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_share_inviting(inputs)
	if (locale === "en") return en_share_inviting(inputs)
	return es_share_inviting(inputs)
});